var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "body__normal-medium" }, [
      _vm._v("\n    Cellular Parameters\n  "),
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "main-container__icon__loader" }),
        ])
      : _vm.error
      ? _c("div", [
          _c("p", { staticClass: "error" }, [
            _vm._v("\n      Error while getting cellular parameters.\n    "),
          ]),
        ])
      : _c("div", [
          _c("div", { staticClass: "ring-card__input-label" }, [
            _vm._v("\n      Imei\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "ring-card__input" }, [
            _vm._v("\n      " + _vm._s(_vm.data["imei"]) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.previousImei
            ? _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n      Previous imei\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.previousImei
            ? _c("p", { staticClass: "ring-card__input" }, [
                _vm._v("\n      " + _vm._s(_vm.previousImei) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ring-card__input-label" }, [
            _vm._v("\n      Eid\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "ring-card__input" }, [
            _vm._v("\n      " + _vm._s(_vm.data["eid"]) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ring-card__input-label" }, [
            _vm._v("\n      Iccid\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "ring-card__input" }, [
            _vm._v("\n      " + _vm._s(_vm.data["iccid"]) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.previousIccIds
            ? _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n      Previous iccids\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.previousIccIds
            ? _c("p", { staticClass: "ring-card__input" }, [
                _vm._v("\n      " + _vm._s(_vm.previousIccIds) + "\n    "),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ring-card__input-label" }, [
      _vm._v("\n      Loading "),
      _c("i", { staticClass: "el-icon-loading" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }